import { normalDecryptData, normalEncryptData } from "config/config";
import { useCookies } from "react-cookie";

const useCookie = () => {
  const [value, setValue, removeValue] = useCookies([
    process.env.REACT_APP_AUTH,
  ]);

  let tomorrow = new Date();
  let today = new Date();
  tomorrow.setDate(today.getDate() + 7);

  const setCookie = (
    data,
    option = {
      path: "/",
      expires: tomorrow,
    }
  ) => {
    setValue(process.env.REACT_APP_AUTH, normalEncryptData(data), option);
  };

  const removeCookie = (
    option = {
      path: "/",
    }
  ) => {
    removeValue(process.env.REACT_APP_AUTH, option);
  };

  const cookies = normalDecryptData(value[process.env.REACT_APP_AUTH]);

  return { cookies, setCookie, removeCookie };
};

export default useCookie;
